'use strict';

var React = require('react');

var SvgGamesConsoleMajor = function SvgGamesConsoleMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7.25a.75.75 0 0 1 .75.75v.5h.5a.75.75 0 0 1 0 1.5h-.5v.5a.75.75 0 0 1-1.5 0v-.5h-.5a.75.75 0 0 1 0-1.5h.5v-.5a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75c-.69 0-1.25.56-1.25 1.25h1.5a4.75 4.75 0 0 1 4.75 4.75v3.343a2.907 2.907 0 0 1-5.685.855l-.332-1.077a.17.17 0 0 0-.163-.121h-1.64a.17.17 0 0 0-.163.12l-.332 1.078a2.907 2.907 0 0 1-5.685-.855v-3.343a4.75 4.75 0 0 1 4.75-4.75h1.5a2.75 2.75 0 0 1 2.75-2.75v1.5Zm-4.25 2.75a3.25 3.25 0 0 0-3.25 3.25v3.343a1.407 1.407 0 0 0 2.752.414l.331-1.078a1.67 1.67 0 0 1 1.597-1.179h1.64a1.67 1.67 0 0 1 1.597 1.18l.331 1.077a1.407 1.407 0 0 0 2.752-.414v-3.343a3.25 3.25 0 0 0-3.25-3.25h-4.5Z"
  }));
};
SvgGamesConsoleMajor.displayName = "GamesConsoleMajor";

exports.SvgGamesConsoleMajor = SvgGamesConsoleMajor;
